import { ApiError } from '@/api/http/types'
import {
  INSTRUMENT_INFO_ALREADY_COMPLETED,
  INSTRUMENT_INFO_CAPACITY_REACHED,
  INSTRUMENT_INFO_CLOSED,
  INSTRUMENT_INFO_PAUSED,
  INSTRUMENT_INFO_START_NETWORK_ERROR,
  INSTRUMENT_NOT_ELIGIBLE,
  INSTRUMENT_UNAVAILABLE,
  SURVEY_SESSION_TIMED_OUT,
} from './instrument-info-messages'
import type { InstrumentInfoEntryViewState } from './types'

export function mapStartSurveyError(error: unknown): {
  message: string
  viewStateOverride?: InstrumentInfoEntryViewState
  /** TC-BE-11 — toast + redirect instead of inline alert. */
  sessionTimeout?: boolean
} {
  if (!(error instanceof ApiError)) {
    return { message: INSTRUMENT_INFO_START_NETWORK_ERROR }
  }

  switch (error.code) {
    case 'already_completed':
      return {
        message: INSTRUMENT_INFO_ALREADY_COMPLETED,
        viewStateOverride: 'alreadyCompleted',
      }
    case 'capacity_reached':
      return {
        message: INSTRUMENT_INFO_CAPACITY_REACHED,
        viewStateOverride: 'capacityReached',
      }
    case 'instrument_paused':
      return { message: INSTRUMENT_INFO_PAUSED, viewStateOverride: 'paused' }
    case 'instrument_unavailable':
      return { message: INSTRUMENT_UNAVAILABLE, viewStateOverride: 'paused' }
    case 'forbidden':
      if (error.status !== 403) {
        return { message: error.message || INSTRUMENT_INFO_START_NETWORK_ERROR }
      }
      return { message: INSTRUMENT_NOT_ELIGIBLE, viewStateOverride: 'notEligible' }
    case 'instrument_closed':
      return { message: INSTRUMENT_INFO_CLOSED, viewStateOverride: 'closed' }
    case 'session_timeout':
      return {
        message: SURVEY_SESSION_TIMED_OUT,
        sessionTimeout: true,
      }
    case 'session_active':
      return {
        message: 'You already have an active session. Use Continue.',
      }
    case 'ekyc_under_review':
      return {
        message:
          error.message ||
          'Your profile verification is under review. Survey participation is unavailable until the review is complete.',
      }
    default:
      return { message: error.message || INSTRUMENT_INFO_START_NETWORK_ERROR }
  }
}
